module.exports = __webpack_public_path__ + "img/ES3111.f4988959.png";